import { Col, Progress, Row } from "antd";
import { get } from "lodash";
import moment from "moment";
import { useTranslation } from "react-i18next";
import Icon from "react-material-symbols/rounded";
import Alert from "shared/components/Alert";
import Button from "shared/components/Button";
import Form from "shared/components/Form";
import Loading from "shared/components/Spin";
import { NAME_SPACES } from "shared/locales/constants";
import format from "string-template";
import { DATE_TIME_FORMAT, PROJECT_TYPES, SALE_MODES } from "utils/constants";
import { STEPPER_KEYS } from "../../..";
import SubscriptionStatus from "./statuses";

const Esignature = ({
  additionalInfoPercentage,
  proofPercentage,
  setActive,
  subscription,
  signDocument,
  signLoading,
}) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.BROKER.CONTRACT);
  const SUBSCRIPTION = t("SUBSCRIPTION", {
    returnObjects: true,
  });
  const E_SIGNATURE = t("SUBSCRIPTION.DOCUMENT.E_SIGNATURE", {
    returnObjects: true,
  });
  const eSignDisabled =
    get(subscription, "project.contract.saleMode") === SALE_MODES.DISTANT &&
    get(subscription, "project.projectType") === PROJECT_TYPES.COLD_LEAD &&
    moment().diff(subscription.createdDate, "hours") <= 24;

  if (signLoading) return <Loading />;

  return (
    <div className="subscription-form--wrapper">
      <Form type="vertical" title={E_SIGNATURE.TITLE}>
        {additionalInfoPercentage < 100 ? (
          <Row gutter={[16, 16]}>
            <Col lg={24} xs={24}>
              <Alert showIcon type="error" message={E_SIGNATURE.INFO} />
            </Col>
            <Col lg={24} xs={24}>
              <div className="progress_wrapper">
                <div className="progress_wrapper--content">
                  <div className="progress_wrapper--content__title">
                    <Icon icon="cake" size={24} />
                    <span>{E_SIGNATURE.FURTHER_INFORMATION}</span>
                  </div>
                  <span className="progress_wrapper--content__percent">
                    {`${additionalInfoPercentage}% ${SUBSCRIPTION.DONE}`}
                  </span>
                </div>
                <div className="progress_wrapper--bar">
                  <Progress
                    percent={additionalInfoPercentage}
                    size={"small"}
                    showInfo={false}
                  />
                </div>
              </div>
            </Col>
            <Col lg={24} xs={24}>
              <div className="progress_wrapper">
                <div className="progress_wrapper--content">
                  <div className="progress_wrapper--content__title">
                    <Icon icon="cake" size={24} />
                    <span>{E_SIGNATURE.ATTACHMENT}</span>
                  </div>
                  <span className="progress_wrapper--content__percent">
                    {`${proofPercentage}% ${SUBSCRIPTION.DONE}`}
                  </span>
                </div>
                <div className="progress_wrapper--bar">
                  <Progress
                    percent={proofPercentage}
                    size={"small"}
                    showInfo={false}
                  />
                </div>
              </div>
            </Col>
            <Col lg={24} xs={24}>
              <Button
                type="primary"
                alignment="center"
                onClick={() =>
                  setActive(
                    additionalInfoPercentage < 100
                      ? STEPPER_KEYS.ADDITIONAL_INFORMATION
                      : STEPPER_KEYS.PROOF
                  )
                }
              >
                {SUBSCRIPTION.FINALIZE_SUBSCRIPTION}
                <Icon icon="edit_note" size={16} />
              </Button>
            </Col>
          </Row>
        ) : (
          <Col lg={24} xs={24}>
            {eSignDisabled && (
              <Alert
                showIcon
                type="warning"
                message={format(E_SIGNATURE.WARNING, {
                  time: moment(subscription.createdDate)
                    .add(24, "hours")
                    .format(DATE_TIME_FORMAT),
                })}
              />
            )}
            <br />
            <SubscriptionStatus
              type={subscription.status}
              subscription={subscription}
              translation={SUBSCRIPTION}
              signDocument={signDocument}
              disabled={eSignDisabled}
            />
          </Col>
        )}
      </Form>
    </div>
  );
};

export default Esignature;
